(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('cart:update', async () => {
    const target = document.querySelector('[data-volbiv-cart-recommendations]');
    if (!target) return;
    const sectionId = target.dataset.volbivCartRecommendations;
    const requestNumber = String(Number(target.dataset.requestNumber || 0) + 1);
    target.dataset.requestNumber = requestNumber;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = html.querySelector('[data-volbiv-cart-recommendations]');
      if (replacement && target.isConnected && target.dataset.requestNumber === requestNumber) {
        target.innerHTML = replacement.innerHTML;
      }
    } catch {}
  });

  } catch(e) { console.error(e); }
})();
})();
